import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants'

const SELECTORS = {
  parent: '.js-hover-gallery',
  live: '.js-hover-gallery-live',
  listItem: '.js-hover-gallery-item',
  listItemButton: '.js-hover-gallery-button',
  listItemFront: '.js-hover-gallery-front',
  listItemBack: '.js-hover-gallery-back'
}

/**
 * Controller for each individual flip card in a gallery
 */
class FeelingsMonsterHoverGallery {
  constructor(element) {
    this.element = element
    this.button = this.element.querySelector(SELECTORS.listItemButton)
    this.front = this.element.querySelector(SELECTORS.listItemFront)
    this.back = this.element.querySelector(SELECTORS.listItemBack)
    this.parent = this.element.closest(SELECTORS.parent)
    this.live = this.parent.querySelector(SELECTORS.live)
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.isMobile = null

    this.init()
  }

  init() {
    this.button.ariaHidden = 'true'
    this.button.tabIndex = '-1'
    this.button.disabled = 'true'

    this.registerEventListeners()
  }

  /**
   * Registers event listeners for card
   */
  registerEventListeners = () => {
    this.element.addEventListener(GLOBAL_CONSTANTS.EVENTS.MOUSEENTER, () => {
      this.showBack(true)
    })

    this.element.addEventListener(GLOBAL_CONSTANTS.EVENTS.MOUSELEAVE, () => {
      this.showFront(true)
    })

    this.element.addEventListener(GLOBAL_CONSTANTS.EVENTS.FOCUSIN, () => {
      this.announceCardState()
    })

    this.element.addEventListener(GLOBAL_CONSTANTS.EVENTS.CLICK, this.flipCard, true)
    this.element.addEventListener(GLOBAL_CONSTANTS.EVENTS.KEYDOWN, this.flipCard, true)

    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.IS_MOBILE, ({ isMobile }) => {
      this.isMobile = isMobile

      this.element.role = this.isMobile ? 'none' : 'button'
      this.element.tabIndex = this.isMobile ? '-1' : '0'
      this.element.ariaPressed = 'false'
      this.element.ariaLabel = this.isMobile ? '' : this.element.dataLabel

      this.live.ariaLive = this.isMobile ? 'off' : 'polite'

      this.front.ariaHidden = !this.isMobile
      this.back.ariaHidden = !this.isMobile
    })
  }

  /**
   * Show the front state of the card
   */
  showFront = () => {
    if (this.isMobile) {
      return
    }

    this.element.ariaPressed = 'false'

    this.announceCardState()
  }

  /**
   * Show the back state of the card
   */
  showBack = () => {
    if (this.isMobile) {
      return
    }

    this.element.ariaPressed = 'true'

    this.announceCardState()
  }

  /**
   * Announce card state change
   */
  announceCardState = () => {
    if (this.isMobile) {
      return
    }

    if (this.element.ariaPressed === 'false') {
      this.live.innerHTML = this.element.dataset.labelFront
    } else {
      this.live.innerHTML = this.element.dataset.labelBack
    }
  }

  /**
   * Toggle the card's front/back state
   * @param {Event} e - The event that fired this action
   */
  flipCard = (e) => {
    if (this.isMobile) {
      return
    }

    const isKbdEvent = e.type === GLOBAL_CONSTANTS.EVENTS.KEYDOWN && (e.key === 'Enter' || e.key === ' ')
    const isClickEvent = e.type === GLOBAL_CONSTANTS.EVENTS.CLICK

    if (isKbdEvent || isClickEvent) {
      e.preventDefault()
      if (this.element.ariaPressed === 'false') {
        this.showBack()
      } else {
        this.showFront()
      }
    }
  }
}

export default {
  selector: SELECTORS.listItem,
  Source: FeelingsMonsterHoverGallery
}
